import { Row, Col, Select } from 'antd';
import TitleUpdater from '../../components/common/TitleUpdater';
import { TitleBar } from '../../components';
import { useCyberHubLocationSelector } from './hooks/useCyberHubLocationSelector';
import { CyberHubTabs, ApplicationsCard, ComplianceCard } from './components';
import { QualitativeFactorsWidget } from './components/widgets/QualitativeFactorsWidget';
import { ProcessAreasWidget } from './components/widgets/ProcessAreasWidget';
import { DRPStatusWidget } from './components/widgets/DRPStatusWidget';
import { RevenueSupportingApplicationsWidget } from './components/widgets/RevenueSupportingApplicationsWidget';
import { ITApplicationsWidget } from './components/widgets/ItApplicationsWidget';
import { BusinessFunctionsWidget } from './components/widgets/BusinessFunctionsWidget';

const { Option } = Select;

export const CyberHubPage = () => {
  const { locations, selectedLocation, locationUuid, handleLocationChange } =
    useCyberHubLocationSelector();

  // Determine column span based on whether Process Areas card should be shown
  const showProcessAreas = !!locationUuid;
  const safeLocationUuid = locationUuid || '';

  const columnSpan = showProcessAreas ? 6 : 8;

  return (
    <>
      <TitleUpdater title="Cyber Hub" />
      <TitleBar title="Cyber Hub" subtitle="Overview" />
      <div className="mb-6">
        <Select
          value={selectedLocation}
          onChange={handleLocationChange}
          style={{ width: 240 }}
          size="large"
          className="border rounded"
        >
          <Option value="Enterprise">Enterprise</Option>
          {locations.map((loc) => (
            <Option key={loc.location} value={loc.location}>
              {loc.location}
            </Option>
          ))}
        </Select>
      </div>

      {/* First row: 3 cards */}
      <Row gutter={[16, 16]} align="stretch" className="mb-4">
        <Col xs={24} md={columnSpan}>
          <ITApplicationsWidget locationUuid={safeLocationUuid} />
        </Col>
        <Col xs={24} md={columnSpan}>
          <BusinessFunctionsWidget locationUuid={safeLocationUuid} />
        </Col>
        <Col xs={24} md={columnSpan}>
          <QualitativeFactorsWidget locationUuid={safeLocationUuid} />
        </Col>
        {showProcessAreas && (
          <Col xs={24} md={columnSpan}>
            <ProcessAreasWidget locationUuid={safeLocationUuid} />
          </Col>
        )}
      </Row>

      {/* Second row: 2 cards */}
      <Row gutter={[16, 16]} align="stretch" className="mt-4">
        <Col xs={24} md={12}>
          <ComplianceCard
            title="Application Workaround Compliance"
            tooltipText="Shows if IT Applications Workarounds meet SLA, RTO, RPO, and MTO."
            onViewClick={() => {}}
            showViewButton={false}
            locationUUID={locationUuid || undefined}
          />
        </Col>
        <Col xs={24} md={12}>
          <DRPStatusWidget locationUuid={safeLocationUuid} />
        </Col>
      </Row>

      {/* Third row: 2 cards */}
      <Row gutter={[16, 16]} align="stretch" className="my-4">
        <Col xs={24} md={12}>
          <RevenueSupportingApplicationsWidget
            locationUuid={locationUuid || ''}
          />
        </Col>
        <Col xs={24} md={12}>
          <ApplicationsCard
            title="Hosting Entities"
            tooltipText="Information about Hosting Entities"
            totalApplications={115}
            percent={40}
            disabled={true}
          />
        </Col>
      </Row>

      {/* Last row: Tabs and Table full width */}
      <CyberHubTabs locationUuid={safeLocationUuid} />
    </>
  );
};
